<div class="menu-indice">MATENIMIENTO DE CORREO DE NOTIFICACION</div>

<mdb-card>
  <mdb-card-body >
    <div class="form-row mb-3 align-items-center">
      <div class="col-1">Asunto:</div>
      <div class="col-10"><input mdbInput type="text" maxlength="200" [(ngModel)]="maeCorreoE.x_asunto"   class="form-control"></div>
    </div>
    <div class="form-row mb-3 align-items-center">
      <div class="col-1">Mensaje:</div>
      <div class="col-10">
        <angular-editor
          [(ngModel)]="maeCorreoE.x_mensaje"
          [config]="editorConfig"
          (keyup)="onKey($event)"
        ></angular-editor>
      </div>
    </div>
    <div class="form-row mb-3 align-items-center">
      <div class="col-1"></div>
      <div class="col-10" style="color: rgb(91, 91, 91);font-size: smaller;">El parámetro <b>xNOMBREx</b> será reemplazado por el nombre del alumno o profesor que recibira el correo.</div>
    </div>
    <div class="form-row mb-3 align-items-center">
      <div class="col-1"></div>
      <div class="col-10" style="color: rgb(91, 91, 91);font-size: smaller;">El parámetro <b>xCURSOx</b> será reemplazado con el nombre del curso, por ejemplo: Curso ESB-007 Introducción a la evaluación de...</div>
    </div>
    <!--
    <div class="form-row mb-3 align-items-center">
      <div class="col-1"></div>
      <div class="col-10" style="color: rgb(91, 91, 91);font-size: smaller;">El parámetro <b>$FECHA$</b> será reemplazado con la fecha actual, por ejemplo: 01-07-2023</div>
    </div>
    -->
    <div class="form-row mb-3 align-items-center" *ngIf="contador>limite_carac">
      <div class="col-1"></div>
      <div class="col-10" style="color: rgb(146, 39, 39);">Limite de caracteres superado</div>
    </div>
    <div class="form-row mb-3 align-items-center" *ngIf="false">
      <div class="col-1">Mensaje html:</div>
      <div class="col-10">
          <textarea mdbInput type="text" readonly maxlength="1500"  rows="6" class="form-control" [(ngModel)]="maeCorreoE.x_mensaje"></textarea>
      </div>
      <div class="col-12" style="text-align: end;">{{contador}}</div>
    </div>
  </mdb-card-body>
</mdb-card>
<mdb-card>
  <mdb-card-body>
    <div class="form-group col-md-12 d-flex justify-content-center" >
      <button mdbBtn type="button" id="btnGuardar" size="md" color="blue-grey" mdbWavesEffect (click)="onProbarEnvio()" >
          <mdb-icon fas icon="paper-plane" class="mr-1"></mdb-icon>PROBAR ENVIO</button>
      <button mdbBtn type="button" id="btnGuardar" size="md" color="blue" mdbWavesEffect (click)="onGuardar()" style="margin-left: 50px;">
        <mdb-icon fas icon="save" class="mr-1"></mdb-icon>GUARDAR</button>
    </div>
  </mdb-card-body>
</mdb-card>
<br>
